"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuditBackendDataProvider = useAuditBackendDataProvider;
const mapAuditListRequest_1 = require("../../../../ui/features/audit/utils/mapAuditListRequest");
const useAuditList_1 = require("../../../../ui/hooks/useAuditList");
function useAuditBackendDataProvider(request, additionalParams) {
    const { request: listAuditRequest, error: mapError } = (0, mapAuditListRequest_1.mapAuditListRequest)(request, additionalParams);
    const { data, isLoading, error, mutate } = (0, useAuditList_1.useAuditList)(listAuditRequest);
    if (listAuditRequest) {
        return {
            data: data
                ? {
                    filteredRowCount: data.total,
                    rows: data.rows,
                }
                : undefined,
            error,
            isLoading,
            reload: mutate,
        };
    }
    return {
        data: undefined,
        error: new Error(mapError),
        reload: () => { },
    };
}
